import { Typography } from 'antd';
import { type CustomWebPageBlockDataFragment } from '../../../../../api/fragments/CustomWebPageBlockData';
import renderMarkdown from '../../../../../utilities/renderMarkdown';
import useTranslatedString from '../../../../../utilities/useTranslatedString';
import { StyledCustomBlockContainer } from '../shared';

type CustomBlockProps = {
    customBlock: CustomWebPageBlockDataFragment;
};

const CustomBlock = ({ customBlock }: CustomBlockProps) => {
    const translated = useTranslatedString();

    return (
        <StyledCustomBlockContainer>
            <div>
                <Typography.Title itemProp="alternativeHeadline" level={2}>
                    {translated(customBlock.title)}
                </Typography.Title>
                {renderMarkdown(translated(customBlock.markdownString))}
            </div>
        </StyledCustomBlockContainer>
    );
};

export default CustomBlock;
